import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'simulation-container',
    template: `
        <div class="simulation">
            <simulation-list></simulation-list>
        </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulationContainer{

    constructor() {}
}
